"use client";

import { usePathname } from "@/navigation";
import dynamic from "next/dynamic";

const HIDDEN_FOOTER_ROUTES = ["/soon"];

const DynamicFooter = dynamic(() => import("@/components/HPFooter"));

const ConditionalFooter = () => {
  const pathname = usePathname();
  if (HIDDEN_FOOTER_ROUTES.some((route) => pathname?.includes(route)))
    return null;
  return <DynamicFooter />;
};

export default ConditionalFooter;
